<template>
  <v-row no-gutters class="pt-10 pb-5" justify="center">
    <v-col cols="12">
      <!-- Export csv - admin only -->
      <v-col cols="12" class="pa-0" v-if="$store.state.auth.role === 'admin'">
        <v-row no-gutters align="center" class="pb-4">
          <v-col>
            <h3>Export dati</h3>
          </v-col>
          <v-tooltip key="index" v-if="this.json.length > 0 && this.loader === false" left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  depressed
                  dark
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="exp">
                <v-icon dark>
                  mdi-download
                </v-icon>
              </v-btn>
<!--              <download-csv
                  class="v-btn v-btn&#45;&#45;depressed v-btn&#45;&#45;fab v-btn&#45;&#45;round theme&#45;&#45;dark v-size&#45;&#45;small primary"
                  v-bind="attrs"
                  v-on="on"
                  delimiter=";"
                  name="export.csv"
                  :data="json">
                <v-icon dark>
                  mdi-download
                </v-icon>
              </download-csv>-->
            </template>
            <span>Esporta</span>
          </v-tooltip>
          <v-tooltip v-if="this.json.length === 0 && this.loader === false" left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  depressed
                  dark
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="csv"
              >
                <v-icon dark>
                  mdi-check
                </v-icon>
              </v-btn>
            </template>
            <span>Esporta</span>
          </v-tooltip>
          <v-tooltip v-if="this.loader === true" left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  depressed
                  dark
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-progress-circular
                    indeterminate
                    color="white"
                    :size="20"
                    :width="2"
                ></v-progress-circular>
              </v-btn>
            </template>
            <span>Esporta</span>
          </v-tooltip>
        </v-row>
        <v-row no-gutters class="white bra align-start justify-space-around pa-3 mb-4">
          <v-col class="col-5">
            Data inizio: <input type="date"  class="input" v-model="from">
          </v-col>
          <v-col class="col-5">
            Data fine: <input type="date"  class="input" v-model="to">
          </v-col>
        </v-row>
      </v-col>
      <!-- List data and create new -->
      <v-row no-gutters align="center" class="pb-4">
        <v-col>
          <h3>Lista Polizze</h3>
        </v-col>
        <v-tooltip left v-if="$store.state.auth.role === 'admin' || $store.state.auth.role === 'user'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                :to="{ name: 'RequestAdd' }"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>
      </v-row>
      <v-row no-gutters class="white bra align-start pa-3">
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="name"
            class="pa-3 pt-0 pb-0"
            no-data-text="Nessun dato disponibile"
            :loading="loading"
            loading-text="Caricamento in corso..."
        >
          <!-- actions -->
          <template v-slot:item.actions="{ item }">
            <!-- actions admin -->
            <div v-if="$store.state.auth.role === 'admin'">
              <action-button :to="{ name: 'RequestEdit', params: {id: item.id } }" icon="mdi-file-document-outline"></action-button>
              <action-confirm @method="del(item.id)" icon="mdi-delete" text="Stai per eliminare definitivamente la polizza selezionata. Confermando non potrà essere più recuperata."></action-confirm>
            </div>
            <!-- actions user -->
            <div v-if="$store.state.auth.role === 'user'">
              <action-button :to="{ name: 'RequestEdit', params: {id: item.id } }" icon="mdi-file-document-outline"></action-button>
            </div>
            <!-- actions user -->
            <div v-if="$store.state.auth.role === 'expert'">
              <action-button :to="{ name: 'RequestEdit', params: {id: item.id } }" icon="mdi-file-document-outline"></action-button>
            </div>
            <!-- actions company -->
            <div v-if="$store.state.auth.role === 'company'">
              <action-button :to="{ name: 'RequestEdit', params: {id: item.id } }" icon="mdi-file-document-outline"></action-button>
            </div>
          </template>

          <!-- status -->
          <template v-slot:item.status="{ item }">
            <!-- status user -->
            <div v-if="$store.state.auth.role === 'user'">
              <strong v-if="item.status < 2" class="accent--text">Da Inviare</strong>
              <strong v-else-if="item.status === 8" class="accent--text">Senza Seguito</strong>
              <strong v-else class="primary--text">Inviata</strong>
            </div>
            <!-- status user -->
            <div v-if="$store.state.auth.role === 'expert'">
              <strong v-if="item.status < 3" class="accent--text">Da inviare</strong>
              <strong v-else class="primary--text">Inviata</strong>
            </div>
            <!-- status company -->
            <div v-if="$store.state.auth.role === 'company'">
              <strong v-if="item.status < 5" class="accent--text">Accetta o Rifiuta</strong>
              <strong v-if="item.status === 5" class="primary--text">Accettata</strong>
              <strong v-if="item.status === 6" class="error--text">Rifiutata</strong>
            </div>
            <!-- status admin -->
            <div v-if="$store.state.auth.role === 'admin'">
              <strong v-if="item.status === 1" class="accent--text">Account</strong>
              <strong v-if="item.status === 2" class="accent--text">Ufficio tecnico</strong>
              <strong v-if="item.status === 3" class="accent--text">Da inviare</strong>
              <strong v-if="item.status === 4" class="accent--text">Inviata</strong>
              <strong v-if="item.status === 5" class="primary--text">Accettata</strong>
              <strong v-if="item.status === 6" class="error--text">Rifiutata</strong>
              <strong v-if="item.status === 7" class="error--text">Polizza emessa</strong>
              <strong v-if="item.status === 8" class="error--text">Senza Seguito</strong>
            </div>
          </template>

          <template v-slot:item.bozza="{ item }">
            <strong v-if="item.filesb && item.filesb.length > 0" class="primary--text">Caricata</strong>
            <span v-else>Non Caricata</span>
          </template>
          <template v-slot:item.attachments="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    depressed
                    dark
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    target="_blank"
                    icon
                    :href="item.report"
                >
                  <v-icon dark>
                    mdi-package-down
                  </v-icon>
                </v-btn>
              </template>
              <span>Download PDF</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    depressed
                    dark
                    small
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    :href="item.package"
                >
                  <v-icon dark>
                    mdi-zip-box
                  </v-icon>
                </v-btn>
              </template>
              <span>Download ZIP</span>
            </v-tooltip>
          </template>
          <template v-slot:item.holder="{ item }">
            <span v-if="item.holder">
              {{item.holder.data.businessName}}
              {{item.holder.data.firstName}}
              {{item.holder.data.lastName}}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.data.sum_insured="{ item }">
            {{item.data.sum_insured}}
            <span v-if="item.data.sum_insured !== null">{{ Number(item.data.sum_insured).toLocaleString("it-IT", {minimumFractionDigits: 2}) }}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  .status {
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
</style>

<script>
    import moment from "moment";
    import { db } from "@/main";
    import firebase from "firebase/app";
    import ActionButton from '@/components/actions/link'
    import ActionConfirm from '@/components/actions/confirm'
    import xlsx from "json-as-xlsx"
    // @ is an alias to /src
    export default {
        name: 'home',
        components: {ActionConfirm,ActionButton},
        methods: {
          del(id) {
            db.collection("requests").doc(id).update({
              deleted_at: new Date()
            }).then(() => {
              this.items.splice(this.items.findIndex(x => x.id === id), 1);
            })
          },
          exp() {
            let settings = {
              fileName: "export", // Name of the resulting spreadsheet
              extraLength: 0, // A bigger number means that columns will be wider
              writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
              writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
              RTL: false, // Display the columns from right-to-left (the default value is false)
            }
            xlsx(this.json, settings)
          },
          async csv() {
            this.json = [
              {
                sheet: "export",
                columns: [
                  { label: "Contraente", value: "contraente" },
                  { label: "Tipologia", value: "tipologia" },
                  { label: "Beneficiario", value: "beneficiario" },
                  { label: "Termine ultimo", value: "termine", format: "dd-mm-yyyy" },
                  { label: "Account", value: "account" },
                  { label: "Produttore", value: "subaccount" },
                  { label: "Data ricezione richiesta", value: "date", format: "dd-mm-yyyy" },
                  { label: "Importo gara", value: "importo", format: "#,##0.00" },
                  { label: "Capitale da garantire", value: "capitale", format: "#,##0.00" },
                  { label: "Durata", value: "durata" },
                  { label: "Premio Indicativo", value: "premio", format: "#,##0.00" },
                  { label: "Tipo firma", value: "firma" },
                  { label: "Stato trattativa", value: "stato" },
                  { label: "Note", value: "note" },
                  { label: "Bozza Caricata", value: "bozza" },
                  { label: "Relazione Tecnica", value: "filest" },
                ],
                content: []
              },
            ]
            this.loader = true
            let res = db.collection("requests").where("deleted_at", "==", null)
            if(this.from != null) {
              res = res.where("created_at", ">=", new Date(this.from))
            }
            if(this.to != null) {
              res = res.where("created_at", "<=", new Date(this.to))
            }
            res = await res.get()
            for (const file of res.docs) {
              let doc = file.data()
              let term = ""
              //let companies = ""
              let contraenti = ""
              let holders = await file.ref.collection("holders").get()
              for (const c of holders.docs) {
                if (c.data().data.businessName && c.data().data.businessName.length > 0) {
                  contraenti += c.data().data.businessName + '\n'
                } else if (c.data().data.first_name && c.data().data.first_name.length > 0) {
                  contraenti += c.data().data.first_name + " " + c.data().data.last_name + '\n'
                }
              }
              let beneficiari = ""
              let beneficiaries = await file.ref.collection("beneficiaries").get()
              for (const c of beneficiaries.docs) {
                console.log("2",c.data().data.businessName)
                if (c.data().data.businessName && c.data().data.businessName.length > 0) {
                  beneficiari += c.data().data.businessName + '\n'
                } else if (c.data().data.first_name && c.data().data.first_name.length > 0) {
                  beneficiari += c.data().data.first_name + " " + c.data().data.last_name + '\n'
                }
              }
              //let status = ""
              /*if(doc.disabled) {
                status = "SI"
              }
              if (doc.companies.length > 0) {
                for (const c of doc.companies) {
                  let snap = await db.collection("companies").doc(c).get()
                  if(snap.exists) {
                    companies += snap.data().name + "\n"
                  }
                }
              }*/
              if(doc.data.guarantee === "Garanzia Provvisoria") {
                term = doc.data.valid_from
              }
              var filest = "NO"
              if(doc.filest && doc.filest.length > 0) {
                filest = "SI"
              }
              this.json[0].content.push({
                contraente: contraenti,
                tipologia: doc.data.guarantee,
                beneficiario: beneficiari,
                termine: term,
                account:  doc.user,
                subaccount:  doc.data.subaccount,
                date: moment(doc.updated_at.toDate()).format("DD-MM-YYYY"),
                importo: Number(doc.data.sum_insured),
                capitale: Number(doc.data.sum_insured),
                durata: doc.data.valid_duration,
                premio: Number(doc.data.insurance_price),
                firma:  doc.data.signature,
                stato: this.getStatus(doc.status),
                bozza: doc.filesb && doc.filesb.length > 0 ? "SI" : "NO",
                note: doc.data.notes,
                filest: filest,
              })
            }
            this.loader = false
          },
          getStatus(status) {
            switch (status) {
              case 1:
                return "Account"
              case 2:
                return "Ufficio Tecnico"
              case 3:
                return "Da inviare"
              case 4:
                return "Inviata"
              case 5:
                return "Accettata"
              case 6:
                return "Rifiutata"
              case 7:
                return "Polizza emessa"
              default:
                return "Senza seguito"
            }
          },
          async setConfirmed(id, val) {
            await db.collection('requests').doc(id).update({
              confirmed: val
            })
            this.$router.go()
          }
        },
        watch: {
          from: function() {
            this.json = []
          },
          to: function() {
            this.json = []
          }
        },
        async mounted () {
          // Binding Collections
          if (this.$store.state.auth.role === "undefined") {
            localStorage.removeItem('fcvbroker')
            this.$store.commit('resetAuth')
            this.$router.replace('/login')
          }
          let snap = []
          if(this.$store.state.auth.role === 'admin') {
            snap = await db.collection("requests").orderBy('updated_at', "desc").get()
          } else if (this.$store.state.auth.role === 'user') {
            snap = await db.collection("requests").where('user_id', '==', firebase.auth().currentUser.uid).orderBy('updated_at', "desc").get()
            // eslint-disable-next-line no-dupe-else-if
          } else if (this.$store.state.auth.role === 'expert') {
            snap = await db.collection("requests").where("status",">=",2).orderBy('status', "asc").orderBy('updated_at', "desc").get()
          } else if (this.$store.state.auth.role === 'company') {
            snap = await db.collection("requests").where('companies', '==', firebase.auth().currentUser.uid).orderBy('updated_at', "desc").get()
          }
          for (const elm of snap.docs) {
            let item = elm.data()
            if (item.deleted_at == null) {
              item.id = elm.id
              let holders = await elm.ref.collection('holders').get()
              if (holders.docs.length > 0) {
                item.holder = holders.docs[0].data()
              }
              this.items.push(item)
            }
          }
          this.loading = false
        },
        data: () => ({
          headers: [
            { text: '', value: 'actions', sortable: false, align: 'center', width: '10%' },
            { text: 'Stato', value: 'status', sortable: false, align: 'center' },
            { text: 'Contraente', align: 'start', value: 'holder'},
            { text: 'Tipologia', align: 'start', value: 'data.guarantee'},
            { text: 'Validità', value: 'data.valid_duration' },
            { text: 'Importo', value: 'data.sum_insured' },
            { text: 'Bozza', align: 'center', value: 'bozza', width: '10%'},
            { text: 'Allegati', align: 'center', value: 'attachments', width: '15%'},
          ],
          search: "",
          items: [],
          loading: true,
          loader: false,
          from: null,
          to: null,
          json: []
        }),
        created() {
/*          let user = firebase.auth().currentUser;
          console.log(user)
          user.updatePassword("").then() => {
            console.log("ok")
            // Update successful.
          }, (err) => {
            console.log(err)
            // An error happened.
          });*/
        }
    }
</script>
